// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3T7eh","head":"ProcedureTableInfo_head__2aL8H"};